export default {"src":"/_next/static/media/circlePlay_24.77bb862c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};